import { Children, useMemo } from 'react';
export function useContent(children) {
    return useMemo(() => Children.toArray(children).reduce((res, item) => {
        var _a;
        const placement = (_a = item === null || item === void 0 ? void 0 : item.props) === null || _a === void 0 ? void 0 : _a.placement;
        return placement ? Object.assign(Object.assign({}, res), { [placement]: item }) : res;
    }, { start: null, end: null }), [children]);
}
//# sourceMappingURL=content.js.map